import { Link } from 'react-router-dom';
import { CreateScene, DeleteScene, EntityScene, ModelScene, IndexScene, UpdateScene } from 'components';
import permissions from 'modules/supplier/category/permissions';
import { Category } from 'modules/supplier/category/types';
import { Form } from './Form';
import { TextField } from '@ff-it/form';
import { TableColumns } from '@ff-it/ui';

const columns: TableColumns<Category> = [
  {
    content: 'Name',
    key: 'name',
    sortable: true,
    render: ({ id, name }: Category) => <Link to={`${id}`}>{name}</Link>,
  },
];

const initialValues = {
  name: '',
};

const model = {
  endpoint: 'supplier/categories/',
  title: 'Category',
  pluralTitle: 'Categories',
  entityTitle: ({ name }: Category) => name,
  permissions,
};

export const route = {
  path: 'categories',
  element: <ModelScene {...model} />,
  children: [
    {
      index: true,
      element: (
        <IndexScene columns={columns} filterFields={<TextField name="search" placeholder="Search.." size="sm" />} />
      ),
    },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues}>
          <Form />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: <EntityScene />,
      children: [
        {
          index: true,
          element: (
            <UpdateScene viewDisabled>
              <Form />
            </UpdateScene>
          ),
        },
        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ],
};
